import React from 'react';
import styled from 'styled-components';
import { Add as PlusIcon } from '@mui/icons-material';
import PageContainer from '../../components/containers/PageContainer';
import FloatingButton from '../../components/buttons/FloatingButton';
import { theme } from '../../assets/styles/theme';
import { usePopup } from '../../providers/PopupProvider';
import OrganizationUploadPopup from './components/OrganizationUploadPopup';
import OrganizationsTable from './components/OrganizationsTable';

const Container = styled.div`
  padding: 0 ${theme.paddingStandard}px;
  flex-direction: column;
  display: flex;
  width: 100%;
`;

const Organizations = () => {
  const { showPopover } = usePopup();

  const handleButtonClick = () => {
    showPopover(<OrganizationUploadPopup />);
  };

  return (
    <PageContainer>
      <Container>
        <OrganizationsTable />
      </Container>
      <FloatingButton onClick={handleButtonClick}>
        <PlusIcon style={{ color: theme.color.white, fontSize: 22 }} />
      </FloatingButton>
    </PageContainer>
  );
};

export default Organizations;
